export default __webpack_public_path__ + "static/btn_img_1-ee829a3b908265fe16c957071cbdfe24.jpg";